import axios from "axios";
// import Cookies from "js-cookie";

const FetchLogin = async (payload) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_API}/login`,
      payload
    );

    if (data.data !== null) {
      localStorage.setItem('authentication', JSON.stringify(data.token));
      localStorage.setItem('userdata', JSON.stringify({
        appFarmerId: data.appFarmerId,
        level: data.level,
        registor: data.registor,
        mobileNo: data.mobileNo,
        idCard: data.idCard
      }));

      return 200

    } else {
      return data.error.status
    }

  } catch (error) {
  }
};

export default FetchLogin;
